var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content resize" },
    [
      _c("e-breadcrumbs"),
      _c("h1", { staticClass: "page_title" }, [
        _vm._v(" KMTC ON NOW로 지금 즉시 운임을 협의해보세요! "),
        _c(
          "a",
          {
            staticClass: "button lg",
            attrs: { href: "#" },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.pdfDownload("KMTC_ON_NOW_FAQ_240821.pdf")
              },
            },
          },
          [_vm._v(" [KMTC ON NOW 이용 가이드 다운로드 (CLICK)]")]
        ),
      ]),
      _c(
        "form",
        { attrs: { id: "frm2" } },
        [
          _c(
            "win-layer-pop",
            { staticClass: "my_surcharge_pop" },
            [
              _vm.customComponent
                ? _c(_vm.customComponent, {
                    tag: "component",
                    attrs: { "parent-info": _vm.surChargeParams },
                    on: { close: _vm.closePopup },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c(
            "win-layer-pop",
            { staticClass: "schedule_kmtc_premium_pop" },
            [
              _vm.customPreComponent
                ? _c(_vm.customPreComponent, {
                    tag: "component",
                    attrs: { "parent-info": _vm.popUpParams },
                    on: { close: _vm.closePremiumPopup },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c("div", { staticClass: "content_box beforetab" }, [
            _c("table", { staticClass: "tbl_search" }, [
              _c("colgroup", [
                _c("col", {
                  attrs: {
                    width: [_vm.serviceCtrCd === "KR" ? "60px" : "80px"],
                  },
                }),
                _c("col", { attrs: { width: "150px" } }),
                _c("col", { attrs: { width: "324px" } }),
                _c("col", { attrs: { width: "50px" } }),
                _c("col", { attrs: { width: "150px" } }),
                _c("col", { attrs: { width: "150px" } }),
                _c("col", { attrs: { width: "80px" } }),
                _c("col", { attrs: { width: "120px" } }),
              ]),
              _c("tbody", [
                _c("tr", [
                  _c("th", [_vm._v(_vm._s(_vm.$t("msg.FARE020T010.001")))]),
                  _c(
                    "td",
                    { attrs: { colspan: "2" } },
                    [
                      _c("e-auto-complete-place", {
                        attrs: {
                          id: "polPol",
                          "ctr-cd": _vm.params.porCtrCd,
                          "plc-cd": _vm.params.porPlcCd,
                          "is-char": true,
                          "is-char-alert": true,
                        },
                        on: { change: _vm.changePol },
                      }),
                    ],
                    1
                  ),
                  _c("th", [_vm._v(_vm._s(_vm.$t("msg.FARE020T010.002")))]),
                  _c(
                    "td",
                    { attrs: { colspan: "4" } },
                    [
                      _c("e-auto-complete-place", {
                        attrs: {
                          id: "podPod",
                          "ctr-cd": _vm.params.dlyCtrCd,
                          "plc-cd": _vm.params.dlyPlcCd,
                          "is-char": true,
                          "is-char-alert": true,
                        },
                        on: { change: _vm.changePod },
                      }),
                    ],
                    1
                  ),
                  _c("td", { staticClass: "text_right" }),
                ]),
                _c("tr", [
                  _c("th", [_vm._v(_vm._s(_vm.$t("msg.FARE020T010.003")))]),
                  _c("td", [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.params.kind,
                            expression: "params.kind",
                          },
                        ],
                        staticClass: "wid150",
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.params,
                              "kind",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                        },
                      },
                      [
                        _c("option", { attrs: { value: "R" } }, [
                          _vm._v(_vm._s(_vm.$t("msg.FARE020T010.005"))),
                        ]),
                      ]
                    ),
                  ]),
                  _c(
                    "td",
                    { attrs: { colspan: "5" } },
                    [
                      _c("e-date-range-picker", {
                        attrs: {
                          id: "date_picker",
                          sdate: _vm.params.fromDt,
                          edate: _vm.params.toDt,
                          "is-debug": true,
                        },
                        on: { change: _vm.changeDateRange },
                      }),
                    ],
                    1
                  ),
                  _c("td", { staticClass: "text_right" }, [
                    _c(
                      "a",
                      {
                        staticClass: "button blue sh",
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.searchMyOceanFreight(true)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("msg.FARE020T010.013")))]
                    ),
                  ]),
                ]),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "content_box mt10" }, [
            _vm._m(0),
            _c("div", {
              style: `display: inline-block; width: 100%; height: ${_vm.gridHeight}px;`,
              attrs: { id: "realgrid" },
            }),
          ]),
          _c("br"),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "flex_box" }, [
      _c(
        "span",
        { staticStyle: { width: "100%", float: "right", "font-size": "15px" } },
        [
          _vm._v(
            "하기 운임 LIST의 운임은 OCEAN FREIGHT와 선적지 LSS 포함 여부만 표시됩니다."
          ),
          _c("br"),
          _vm._v(
            " 기타 LOCAL CHARGE, SURCHARGE를 확인하시려면 S/C No.를 클릭 부탁드립니다. "
          ),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }